import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query"
import { toast } from "@/components/ui/toast"
import { extractErrorMessage } from "@/shared/lib/errors"

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Only toast for queries that opted in via meta.toastOnError
      if (query.meta?.toastOnError) {
        toast.error(extractErrorMessage(error, "Ошибка загрузки данных"))
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      if (mutation.meta?.silent) return
      // Mutations with their own onError still bubble here; skip if they set silent.
      if (mutation.options.onError) return
      toast.error(extractErrorMessage(error, "Не удалось сохранить изменения"))
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
})
